import { Storage } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import LoadingImage from '../Images/loading_image.jpg'
import ImageUnavailable from "../Images/Image_not_available.png"
import { Image } from 'primereact/image';

const AuthroizedImages = React.memo(
    ({ ProductImage, imageStyle, onClick }) => {

        const [imageUrl, setImageUrl] = useState(null);

        useEffect(() => {
            const fetchImageUrls = async () => {
                setImageUrl(LoadingImage);
                const imageKey = ProductImage.split("public/")[1];
                if (imageKey) {
                    try {
                        const imageValue = await Storage.get(imageKey);
                        setImageUrl(imageValue);
                    } catch (error) {
                        console.error('Error fetching image from storage:', error);
                        setImageUrl(ImageUnavailable);
                    }
                }
            };
            if (ProductImage) {
                fetchImageUrls();
            }
        }, [ProductImage]);
        return (
            <div className='flex justify-content-center align-items-center fadein animation-duration-400'>
                <Image imageStyle={imageStyle} src={imageUrl ? imageUrl : LoadingImage} alt="Image" onClick={onClick}
                    onError={(e) => {
                        e.target.src = ImageUnavailable;
                        e.target.alt = "Product";
                    }} />
            </div>
        )
    }
)

export default AuthroizedImages